'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import logger from '@/lib/logger';
export function useGlobalErrorLogger() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp3, t0);
}
function _temp3() {
  const handleError = _temp;
  const handleUnhandledRejection = _temp2;
  window.addEventListener("error", handleError);
  window.addEventListener("unhandledrejection", handleUnhandledRejection);
  return () => {
    window.removeEventListener("error", handleError);
    window.removeEventListener("unhandledrejection", handleUnhandledRejection);
  };
}
function _temp2(event_0) {
  const {
    reason,
    promise
  } = event_0;
  const errorDetails = serializeUnknownError(reason);
  const promiseDetails = serializeUnknownError(promise);
  logger.error("[Unhandled Promise Rejection]", {
    errorDetails,
    promise: promiseDetails
  });
}
function _temp(event) {
  logger.error("[Global Error]", {
    message: event.message,
    source: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error ? serializeError(event.error) : undefined
  });
}
function serializeError(error: Error): Record<string, unknown> {
  const base = {
    type: error.name,
    message: error.message,
    stack: error.stack
  };
  const customProps = Object.getOwnPropertyNames(error).reduce((acc, key) => {
    acc[key] = (error as any)[key];
    return acc;
  }, {} as Record<string, unknown>);
  return {
    ...base,
    ...customProps
  };
}
function serializeUnknownError(reason: unknown): Record<string, unknown> {
  if (reason instanceof Error) {
    return serializeError(reason);
  }
  if (typeof reason === 'object' && reason !== null) {
    return {
      type: reason.constructor?.name || 'UnknownObjectError',
      code: (reason as any).code || 'UnknownErrorCode',
      message: (reason as any).message || 'Unknown error occurred',
      stack: (reason as any).stack || 'No stack trace available',
      ...reason
    };
  }
  return {
    type: typeof reason,
    value: reason
  };
}